module.exports = __webpack_public_path__ + "img/ml.593dcabf.svg";